import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { getText } from "../utils/texts";

const SuccessModal = ({ open, onClose, language }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
          textAlign: "center"
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        {getText("paymentSuccessful", language)}
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 3
          }}
        >
          <Box
            sx={{
              animation: "glow 2s infinite",
              "@keyframes glow": {
                "0%": {
                  boxShadow: "0 0 0 0 rgba(255, 215, 0, 0.7)"
                },
                "70%": {
                  boxShadow: "0 0 0 10px rgba(255, 215, 0, 0)"
                },
                "100%": {
                  boxShadow: "0 0 0 0 rgba(255, 215, 0, 0)"
                }
              }
            }}
          >
            <StarIcon
              sx={{
                fontSize: 80,
                mb: 2,
                color: "#FFD700", // Gold color for the star
                animation: "spin 2s infinite linear, bounce 1s ease-in-out",
                "@keyframes spin": {
                  "0%": {
                    transform: "rotate(0deg) scale(1)"
                  },
                  "50%": {
                    transform: "rotate(180deg) scale(1.2)"
                  },
                  "100%": {
                    transform: "rotate(360deg) scale(1)"
                  }
                },
                "@keyframes bounce": {
                  "0%": {
                    opacity: 0,
                    transform: "scale(0.3) rotate(0deg)"
                  },
                  "50%": {
                    opacity: 0.9,
                    transform: "scale(1.1) rotate(180deg)"
                  },
                  "80%": {
                    opacity: 1,
                    transform: "scale(0.89) rotate(288deg)"
                  },
                  "100%": {
                    opacity: 1,
                    transform: "scale(1) rotate(360deg)"
                  }
                }
              }}
            />
          </Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {getText("paymentSuccessMessage", language)}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120, borderRadius: 2 }}
        >
          {getText("close", language)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;